/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { Analytics } from '../../../analytics/sendAnalyticsEvent';
import { ANALYTICS_EVENTS } from '../../../constants';
import { formatBasePrice } from '../../../analytics/formatPrice';

export default (set, get, payload) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const {
    sku,
    quantity = 1,
    unitPrice = 0,
    experienceName = 'wall storage builder',
    feature = 'products list',
    interactionType = 'add to wall',
    emitClickEvent = false,
    emitItemAddedEvent = true,
  } = payload || {};

  const clickEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: ANALYTICS_EVENTS.CONFIGURATOR_CLICK },
    content: {
      module: [{
        name: experienceName,
        feature,
        type: interactionType,
      }],
    },
  };

  if (emitClickEvent) {
    Analytics.sendAnalyticsEvent(clickEvent);
  }

  if (emitItemAddedEvent) {
    const basePrice = +(unitPrice * quantity);
    const itemAddedEvent = {
      category: { primaryCategory: 'button submission' },
      eventInfo: { eventName: 'bundle add' },
      item: [{
        quantity,
        price: { basePrice: formatBasePrice(basePrice) },
        productInfo: { sku },
      }],
    };

    draft.digitalData.productSelect = {
      clickEvent,
      itemAddedEvent,
    };

    Analytics.sendAnalyticsEvent(itemAddedEvent);
  }
}), false, { type: 'TRACK_PRODUCT_SELECT' });
